import styled from "styled-components";


export const Container = styled.footer`
  background: linear-gradient(180deg, rgba(255,255,255,0.02), rgba(255,255,255,0.01));
  border-top: 1px solid var(--glass-border);
  padding: 3.2rem 8rem;
  margin-top: 8rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.6rem;

  .logo{
    font-size: 2.4rem;
    font-weight: 700;
    color: var(--text);
  }

  .copyright{
    color: var(--muted);
    font-size: 1.4rem;
  }

  p{
    letter-spacing: 0.04rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin: 0;
    img{
      width: 2.2rem;
      animation: spinning 6s infinite linear;
      filter: drop-shadow(0 6px 16px rgba(2,6,23,0.45));
    }
  }
  .social-media{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 1rem;

    a{ display:inline-flex; align-items:center; justify-content:center; }

    img,span{
      width: 3.2rem; height:3.2rem; display:block; transition: transform 160ms ease, filter 160ms ease;
      filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(332deg) brightness(100%) contrast(101%);
    }
    img:hover{ transform: translateY(-4px) scale(1.03); filter: none; }
  }

  @keyframes spinning {
    0%{ transform: rotate(0); }
    100%{ transform: rotate(360deg); }
  }

  @media(max-width: 800px){
    padding: 3.2rem 3rem;
    flex-direction: column;
    gap: 1.6rem;
    text-align: center;
    .social-media{ justify-content:center; }
  }
  @media(max-width: 600px){
    padding: 3rem 1rem;
    .copyright{ font-size: 1.2rem; }
  }
`